import { useEffect, useState, useContext } from 'react';
import { HotelContext } from '../context/hotel'
import { fetch, fetchAll } from '../services/api';
// import { listItemsForCaching } from '../graphql/queries';
import { usePersistentState } from './usePersistentState';
import { useLocalStorage } from "@penseapp/uselocalstorage";
import useApi from "./useApi";

export const useItems = (entity) => {
    const { data: hotel, cacheVersion } = useContext(HotelContext);
    const { get } = useApi();
    const [loading, setLoading] = useState(false)
    const [items, setItems] = useState(null)
    // const [ items, setItems ] = usePersistentState(`${entity}-${cacheVersion}`, null, hotel?.code === "comahue" ? 1440 : 30)
    // const [ items, setItems ] = useLocalStorage(`${hotel.id}-${entity}-${cacheVersion}`, null, 60 * 30);
    const [error, setError] = useState(null)

    console.log('08nov - ${entity}-${cacheVersion}', `${entity}-${cacheVersion}`)

    const getFetch = (entity) => {
        if (!hotel || !entity) {
            setError("Invalid hotel or entity");
            return null;
        }
        if (entity === "items") {
            console.log('TODO - listItemsForCaching')
            // return fetchAll(listItemsForCaching, {
            //     hotelId: hotel.id
            // }, 200)
        }
        const url = `hotels/${hotel.id}/${entity}`;
        return get(url);
    }

    const loadItems = async () => {
        setLoading(true);
        const _fetch = getFetch(entity);
        if (_fetch) {
            try {
                const response = await _fetch;
                setItems(entity === "items" ? response.data || [] : response || []);
            } catch (err) {
                setError(`Error fetching '${entity}': ${err.message}`);
            } finally {
                setLoading(false);
            }
        }
    };

    const getItemById = id => {
        if (!items) return null;
        return items.find(i => i.id === id);
    }

    useEffect(() => {
        console.log('08nov - items', items)
        console.log('08nov - entity', entity)
        if (items === null) {
            setLoading(true)
            loadItems()
        }
    }, [])

    const getItemsByType = (type) => {
        return get(`hotels/${hotel.id}/items?type=${type}`)
    }

    

    // const dispatch = useDispatch()
    // const { restaurants: _restaurants } = useSelector(state => state.hotelReducer)
    // const entityInitialState = { loading: false, data: null, error: null }
    // const [ entityLoaded, setEntityLoaded ] = useState([])
    // // const entityLoadedRef = useRef([]);
    // const [ entityState, setEntityState ] = useState({ 'restaurants' : entityInitialState })

    // // const [ restaurantsState, setRestaurantsState ] = useState()

    // // usePersistedState('restaurants', { loading: false, data: null, error: null });

    // const getEntity = useCallback((entity) => {
    //     const state = entityState[entity]

    //     console.log('useItems:: getEntity', entity)
    //     console.log('useItems:: 2', state)
    //     // if (!entityState[entity]) {
    //     //     console.log('useItems:: 3')
    //     //     setEntityState({ ...entityState, [entity]: { ...entityInitialState } })
    //     // }
    //     console.log('useItems:: 4', entityState)
    //     if (!state.loading && state.data === null) {
    //         state.loading = true
    //         setEntityState({ ...entityState, [entity] : { ...state } })
    //         console.log('useItems:: ?????')
    //         const restData = getRestaurantes()
    //         // if (restData) {
    //         //     console.log('useItems:: 4..5', restData)
    //         //     state.loading = false
    //         //     state.data = restData
    //         //     setEntityState({ ...entityState, [entity] : { ...state } })
    //         // }
    //     }
    //     console.log('useItems:: 5', state)
    //     // return entityState[entity]
    //     // const restData = await getRestaurantes()
    //     // if (restData) {
    //     //     setRestaurants(restData)
    //     // }
    // }, [entityState])

    // const loadEntity = useCallback((entity) => {
    //     if (entityLoaded.indexOf(entity) === -1) {
    //         getEntity(entity)
    //         setEntityLoaded([ ...entityLoaded, entity ])
    //         console.log('useItems:: 11', [ ...entityLoaded, entity ])
    //         console.log('useItems:: 22', entityLoaded)
    //     }
    // }, [ entityLoaded ])

    // const restaurants = useMemo(() => {
    //     loadEntity('restaurants')
    //     return entityState['restaurants']
    // }, [ entityState['restaurants'] ])




    //     // if (!_restaurants) {
    //     //     console.log('--->')
    //     //     getRestaurantes()
    //     //     console.log('--->')
    //     // }
    //     // return _restaurants
    //     // if (!rest) {
    //         console.log('--->')
    //         const restData = await getRestaurantes()
    //         console.log('restData', restData)
    //         console.log('restData', JSON.stringify(restData))
    //         // setRest(restData)
    //         console.log('--->')
    //     // }
    //     return rest
    // })

    return {
        loadItems,
        loading,
        items,
        getItemById,
        error,
        getItemsByType
    }
}